<template>
  <div class="container-fluid">
    <div class="card">
      <div class="card-body">
        <h3>Cadastro de Funil de venda</h3>
        <div class="dropdown-divider"></div>
        <h5>Aqui vamos cadastrar e editar toda a base de funil de venda</h5>
        <table class="table table-sm table-hover table-striped tableCrmFunnels">
          <thead>
            <tr>
              <th data-column-id="_id" data-visible="false">ID</th>
              <th data-align="center" data-column-id="e" data-formatter="e" data-sortable="false" data-width="36px"></th>
              <th data-column-id="name" data-sortable="true" data-order="asc">Nome</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {initGrid} from 'hennig-common'

export default {
  name: 'CrmFunnel',
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const addLabel = 'Novo'
      const collectionObj = 'CrmFunnel'
      initGrid({
        container: $(this.$el).find('table'),
        collectionObj,
        rowClick: true,
        addLabel
      })
    }
  }
}
</script>

<style scoped>

</style>
